import PropTypes from "prop-types";
import { compact } from "lodash";
import { Helmet } from "react-helmet";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";

export const PageTitle = ({ title }) => {
  const { currentCommunity } = useCurrentCommunityContext();
  const fullTitle = compact([title, currentCommunity?.name]).join(" | ");
  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
